import { render, staticRenderFns } from "./addresses-and-extra-info.vue?vue&type=template&id=42d8f7e5&lang=pug&"
import script from "./addresses-and-extra-info.vue?vue&type=script&lang=js&"
export * from "./addresses-and-extra-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports